import { render, staticRenderFns } from "./MealPreferenceMergeTags.vue?vue&type=template&id=7bab870d"
import script from "./MealPreferenceMergeTags.vue?vue&type=script&lang=js"
export * from "./MealPreferenceMergeTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports